export default "/images/da8b678351460fb706f652372b62c653.avif";